<script setup>
import { CheckCircle2, AlertCircle, Info, X } from '@lucide/vue';

defineProps({
  type: {
    type: String,
    default: 'info', // 'success' | 'error' | 'info' | 'warning'
  },
  message: {
    type: String,
    default: '',
  },
  dismissible: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['dismiss']);
</script>

<template>
  <div
    v-if="message"
    :class="[
      'p-4 rounded-xl text-xs font-medium border flex items-start gap-3 transition shadow-sm',
      type === 'success' ? 'bg-emerald-50 border-emerald-200 text-emerald-800' : '',
      type === 'error' ? 'bg-rose-50 border-rose-200 text-rose-800' : '',
      type === 'info' ? 'bg-indigo-50 border-indigo-200 text-indigo-800' : '',
      type === 'warning' ? 'bg-amber-50 border-amber-200 text-amber-800' : '',
    ]"
  >
    <CheckCircle2 v-if="type === 'success'" class="w-4 h-4 text-emerald-600 shrink-0 mt-0.5" />
    <AlertCircle v-else-if="type === 'error'" class="w-4 h-4 text-rose-600 shrink-0 mt-0.5" />
    <Info v-else class="w-4 h-4 text-indigo-600 shrink-0 mt-0.5" />

    <div class="flex-1 leading-relaxed">
      {{ message }}
    </div>

    <button
      v-if="dismissible"
      @click="emit('dismiss')"
      type="button"
      class="text-slate-400 hover:text-slate-600 p-0.5 rounded transition"
    >
      <X class="w-3.5 h-3.5" />
    </button>
  </div>
</template>
